import { Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
} from '@core/user-interface-legacy';

import { Destroyable } from '../../../common';
import type { Offer } from '../types';

type DialogData = {
  duplicateOffer: Offer;
};

@Component({
  selector: 'rti-gfea-duplicate-posting-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gfea-duplicate-posting-dialog.component.html',
  styleUrls: ['./gfea-duplicate-posting-dialog.component.less'],
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    TranslatePipe,
  ],
})
@Destroyable()
export class GfeaDuplicatePostingDialogComponent implements DialogComponentI<DialogData, boolean> {
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly cdRef = inject(ChangeDetectorRef);
  public readonly dialog = inject(DialogRef);

  public dialogData: DialogData;

  public setDialogData(data: DialogData): void {
    this.dialogData = data;
    this.cdRef.detectChanges();
  }

  public openDuplicateOffer(): void {
    const urlTree = this.router.createUrlTree(
      ['/offers', this.dialogData.duplicateOffer.slug, 'promote', 'job_boards'],
      { queryParamsHandling: 'preserve' },
    );
    window.open(this.location.prepareExternalUrl(this.router.serializeUrl(urlTree)), '_blank');
    this.dialog.close();
  }

  public close(): void {
    this.dialog.close();
  }
}
